import { mapActions, mapState } from 'vuex';
import staticPageHeader from '@/components/static-page-header/static-page-header.vue';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import seoMetaMixin from '@/mixins/seoMeta';

export default {
  mixins: [
    loaderMixin,
    contentLoaderMixin,
    seoMetaMixin,
  ],
  metaInfo() {
    return this.buildSeoMeta({
      title: 'Site Map',
    });
  },
  computed: {
    ...mapState('about', ['sitemap']),
    enabledGroups() {
      const disabledGroupForSimplifiedDemoSite = [];
      return this.sitemap.groups.filter((item) => {
        if (disabledGroupForSimplifiedDemoSite.includes(item.name.toLowerCase())) {
          return false;
        }
        return true;
      });
    },
  },
  components: {
    staticPageHeader,
  },
  methods: {
    ...mapActions('about', ['getSitemap']),
    enabledGroupItems(items) {
      return items.filter((item) => {
        if (item.name.toLowerCase() === 'research') {
          return false;
        }
        return true;
      });
    },
  },
  created() {
    this.loaderAdd(document.body);
    this.getSitemap()
      .then(() => {
        this.isComponentReady = true;
        this.loaderRemove(document.body);
    }).catch(() => this.loaderRemove(document.body));
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-sitemap/page-sitemap.js